import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=040a23d1&scoped=true&"
import script from "./forgot-password.js?vue&type=script&lang=js&"
export * from "./forgot-password.js?vue&type=script&lang=js&"
import style0 from "./forgot-password.scss?vue&type=style&index=0&id=040a23d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040a23d1",
  null
  
)

export default component.exports